import React from 'react';

import { Text } from '~/components/core';
import Link from '~/components/core/Atomic/Link/Link';
import { QuestionCircleIcon } from '~/components/icons';
import colors from '~/theme/tailwind/colors';

export const HowToUseTableauLink: React.FC = () => {
  return (
    <span className="flex items-center gap-12">
      <QuestionCircleIcon iconColor={colors.teal[700]} />
      <Link
        className="text-teal-700"
        href="https://help.tableau.com/current/pro/desktop/en-us/datafields_understanddatawindow.htm"
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
      >
        <Text variant={Text.VARIANTS.LG} weight={Text.WEIGHTS.SEMI_BOLD} className="text-teal-700">
          How to use Tableau
        </Text>
      </Link>
    </span>
  );
};
